import React from 'react';

import { RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import BaseDatePicker from 'components/BaseForm/BaseDatePicker';
import BaseForm from 'components/BaseForm/BaseForm';
import { FormInputProps } from 'components/BaseForm/types';
import { CSSUtils } from 'utils/CSSUtils';

import {
  HistoriqueAction,
  RecuperationActionsUtilisateurFormInProgressStatus,
  RecuperationActiviteUtilisateurFormValues,
} from '../types';

import FormFooter from './FormFooter/FormFooter';

interface RecuperationActionsUtilisateurFormProps {
  validate: (
    field: RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum,
    changedValues: RecuperationActiviteUtilisateurFormValues,
  ) => Promise<void>;
  onCancel: () => void;
  values: RecuperationActiviteUtilisateurFormValues;
  submit: (values: RecuperationActiviteUtilisateurFormValues) => void;
  handleClick: (historiqueAction: HistoriqueAction) => void;
  inProgressActionStatus?: RecuperationActionsUtilisateurFormInProgressStatus;
}

function RecuperationActionsUtilisateurForm({
  validate,
  onCancel,
  values,
  submit,
  handleClick,
  inProgressActionStatus,
}: RecuperationActionsUtilisateurFormProps) {
  const inputs: FormInputProps<
    RecuperationActiviteUtilisateurFormValues,
    RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum
  >[] = [
    {
      field: RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum.ID,
      label: 'ID Utilisateur Keycloak ou Passage2 (Nigend/RIO)',
      dependencies: ['nom', 'prenom'],
      name: 'id',
    },
    {
      field: RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum.NOM,
      label: 'Nom',
      dependencies: ['id', 'prenom'],
      name: 'nom',
    },
    {
      field: RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum.PRENOM,
      label: 'Prénom',
      dependencies: ['id', 'nom'],
      name: 'prenom',
    },
    {
      field:
        RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum.DATE_DEBUT,
      label: 'Date de début',
      name: 'dateDebut',
      dependencies: ['dateFin'],
      render: () => {
        return <BaseDatePicker />;
      },
    },
    {
      field: RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum.DATE_FIN,
      label: 'Date de fin',
      name: 'dateFin',
      dependencies: ['dateDebut'],
      render: () => {
        return <BaseDatePicker />;
      },
    },
  ];

  return (
    <BaseForm
      initialValues={values}
      validateField={validate}
      onSubmit={submit}
      onCancel={onCancel}
      inputs={inputs}
      renderButtonAction={(
        _submitButton,
        _cancelButton,
        hasError?: boolean,
      ) => (
        <FormFooter
          onCancel={onCancel}
          handleClick={handleClick}
          hasError={hasError}
          inProgressActionStatus={inProgressActionStatus}
        />
      )}
      wrapperCol={{ span: CSSUtils.LlargeWrapperCol }}
    />
  );
}
export default RecuperationActionsUtilisateurForm;
